<template>
  <div class="main-container test-content">
    <div class="bread">
      <router-link :to="{ name: 'MemberTest' }">我的考试</router-link>
      <span class="slash">/</span>
      <span class="current">{{ testInfo.name }}</span>
    </div>
    <div class="main-content">
      <div class="test-title" :title="testInfo.name">{{ testInfo.name }}</div>
      <div class="divider-content">
        <div class="divider"></div>
        <div class="test-introduce">
          <div
            v-for="item in testInfo.introduce"
            :key="item.id"
            style="z-index: 10; background: #fff; padding: 0 5px"
          >
            <label class="label">{{ item.label }}：</label>
            <span class="value">{{ item.value }}{{ item.unit }}</span>
          </div>
        </div>
      </div>
      <div class="test-introduce-first">
        <div class="first-title">一、考试说明</div>
        <div class="first-content">
          {{ testInfo.remark || '暂无考试说明' }}
        </div>
      </div>
      <div class="test-introduce-first">
        <div class="first-title">二、考试结构</div>
        <div class="second-content">
          <div class="table-title">
            <span v-for="(item, index) in testInfo.info" :key="index" class="item-title">
              {{ item.title }}
            </span>
          </div>
          <div class="table-content">
            <span class="item-content" v-for="(item, index) in testInfo.info" :key="index">
              {{ item.count }}题 ({{ item.score }}分)
            </span>
          </div>
        </div>
      </div>
      <div class="footer-button">
        <div class="confirm-button" @click="goToTest">进入考试</div>
      </div>
    </div>
    <TestCheckModal ref="checkModal" />
  </div>
</template>

<script>
import TestCheckModal from '../member/components/TestCheckModal';
export default {
  name: 'TestDetail',
  components: {
    TestCheckModal,
  },
  data() {
    return {
      id: this.$route.query.id,
      tableTitle: [
        { type: 1, value: '单选题' },
        { type: 2, value: '判断题' },
        { type: 3, value: '多选题' },
        { type: 4, value: '不定项选择题' },
        { type: 5, value: '简答题' },
        { type: 6, value: '材料题' },
        { type: 7, value: '填空题' },
      ],
      introduce: [
        {
          label: '答卷时长',
          value: '',
          id: 'time',
          unit: '分钟',
        },
        {
          label: '试题总数',
          value: '',
          id: 'ques_num',
          unit: '题',
        },
        {
          label: '考试分数',
          value: '',
          id: 'score',
          unit: '分',
        },
        {
          label: '通过分数',
          value: '',
          id: 'pass_score',
          unit: '分',
        },
      ],
      testInfo: {
        introduce: [],
      },
    };
  },
  created() {
    this.getTestInfo();
  },
  methods: {
    async getTestInfo() {
      const res = await this.$http.get(`/api/app/test/entranceTest/${this.id}`);
      let count = 0,
        score = 0;
      res.info.forEach((i) => {
        i.title = this.getTitle(i.type);
        count += i.count;
        score += i.score;
      });
      res.info.push({ title: '总计', count, score });
      this.testInfo = res;
      res.time = res.time / 60; //答卷时长，单位是秒
      this.testInfo.introduce = this.introduce.map((i) => {
        if (i.id == 'time' && !res[i.id]) {
          return {
            ...i,
            value: '不限制',
            unit: '',
          };
        }
        return {
          ...i,
          value: res[i.id],
        };
      });
    },
    getTitle(type) {
      const data = this.tableTitle.find((i) => i.type == type) || {};
      return data.value;
    },
    async goToTest() {
      let data = await this.$http.post('/api/app/practice/report', {
        type: 7,
        test_id: this.id,
      });
      if (data.length === 0) {
        this.$info('当前没有题目可以练习');
        return;
      }
      await this.$refs.checkModal.init(this.id);
      this.$router.push({
        name: 'TestDo',
        query: { id: data, package_id: this.id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.test-content {
  margin-bottom: 40px;
  .main-content {
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 24px 24px 56px 24px;
    margin-bottom: 30px;
    .test-title {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
      text-align: center;
      height: 26px;
      margin-bottom: 16px;
      margin-left: 26px;
      max-width: 1100px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .divider-content {
      position: relative;
      .test-introduce {
        margin: 0 96px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        height: 24px;
        .label {
          display: inline-block;
        }
        .value {
          color: #333;
        }
      }
      .divider {
        height: 1px;
        width: 100%;
        border-bottom: 1px dashed #cbcbcb;
        position: absolute;
        top: 11px;
        left: 0;
      }
    }
    .test-introduce-first {
      margin-top: 40px;
      .first-title {
        height: 24px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
      .first-content {
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
      }
      .second-content {
        margin-top: 12px;
        border: 1px solid #dbdbdb;
        border-radius: 8px;
        height: 86px;
        width: 100%;
        overflow: hidden;
        .table-title {
          display: flex;
          height: 43px;
          line-height: 43px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #333333;
          border-bottom: 1px solid #dbdbdb;
          span {
            flex: 1;
            background: #f0f0f0;
            border-right: 1px solid #dbdbdb;
            text-align: center;
            &:last-child {
              border: none;
            }
          }
        }
        .table-content {
          display: flex;
          height: 43px;
          line-height: 43px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #666;
          span {
            flex: 1;
            border-right: 1px solid #dbdbdb;
            text-align: center;
            &:last-child {
              border: none;
            }
          }
        }
      }
    }
    .footer-button {
      //text-align: center;
      display: flex;
      justify-content: center;
      margin-top: 56px;
      .confirm-button {
        //display: inline-block;
        width: 160px;
        height: 42px;
        background: $primary-color;
        border-radius: 22px;

        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 42px;
        cursor: pointer;
      }
    }
  }
}
</style>
